import { z } from 'zod';

export const BcmRpoSchema = z.object({
    id: z.string().optional(),
    value: z.number().min(0),
    unit: z.enum(['minutes', 'hours', 'days']),
    description: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateBcmRpoSchema = BcmRpoSchema.omit({ id: true });
export const UpdateBcmRpoSchema = BcmRpoSchema;